import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 02 Aug 2025 03:02 AM ( BRT ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.deOn3VSg-Cp9_kS_VJ0vjWH7-2L0X7ZIblbHx2sD5udMprYKXBgSc0n3OrY5e6uJ8tEnwmkm_NKTVbx5uwUb_TndQcoaTS1GSSTCfUpPTkd_E1x5xvKh3AuxSbMchzqRFBHc-bBVWEtvGilAkMYd83IGtkhkdVNXtlihwE_tKCzapuUKblNjiedaYltvb_278x41fctprX4Pj0mbAUFQKiT8MkWVIUUXdPepm1XnCj0GdbOWRFqN9gyL-Q63wzN5YPVpm8IT8nauHUUrx7nbXAxAitsPoWM",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-08-09T01:03:49.147972Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2025-08-02T01:03:42+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.deOn3VSg-Cp9_kS_VJ0vjWH7-2L0X7ZIblbHx2sD5udMprYKXBgSc0n3OrY5e6uJ8tEnwmkm_NKTVbx5uwUb_TndQcoaTS1GSSTCfUpPTkd_E1x5xvKh3AuxSbMchzqRFBHc-bBVWEtvGilAkMYd83IGtkhkdVNXtlihwE_tKCzapuUKblNjiedaYltvb_278x41fctprX4Pj0mbAUFQKiT8MkWVIUUXdPepm1XnCj0GdbOWRFqN9gyL-Q63wzN5YPVpm8IT8nauHUUrx7nbXAxAitsPoWM'

// {
//   "access_token": "v2.local.UfOm8XC2yexLC3af6acfoi2MXTzyyroqBWpAvcGfNXRTQtBUcA-Y72lgJltTiigKUB0vDNDdt1tvi7Mml081U4GOMjbZVLBPbkWJ8UfEhKk9KN62iyasxzIZDnSaF43ZZONenAVufpRO9xwTMk_8L9ZZBl-95LD0FBZVMmUpNiE0OG3OR0yS-faLTZARqtvom-_6eudTX8mJ9ac_b5wcmnnBDZmj6lgky2S3fLA1PoZpFg17g_TvIuCstnQgClahshLxDChUvoAGkzI2L7aSu8YAjmpWKJ4",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-08-09T01:04:37.069629Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2025-08-02T01:04:34+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.UfOm8XC2yexLC3af6acfoi2MXTzyyroqBWpAvcGfNXRTQtBUcA-Y72lgJltTiigKUB0vDNDdt1tvi7Mml081U4GOMjbZVLBPbkWJ8UfEhKk9KN62iyasxzIZDnSaF43ZZONenAVufpRO9xwTMk_8L9ZZBl-95LD0FBZVMmUpNiE0OG3OR0yS-faLTZARqtvom-_6eudTX8mJ9ac_b5wcmnnBDZmj6lgky2S3fLA1PoZpFg17g_TvIuCstnQgClahshLxDChUvoAGkzI2L7aSu8YAjmpWKJ4'

// {
//   "access_token": "v2.local.dFRdzG6vVwIKaxO6WpCLF5q1vPTEPGJdHr2ZufUPMzO8NzijP72yr0oVbknaOTwkw7cgv6403u7N1tW1ejXVChtJieavs3bSiXtZc-pmd7b5RSy4HnocFKsdwYDOcfIiW94ka_wrIG4Wa3TiMTD3mqLFWtdFw0gPe2eeJnGs1R7F37WjFFlJPAK_7HqwhZdI-u4XNRNqr0kXIM15u59espxcA1MmQ7doAHv6awL0c--y0TQj0iDcuGrzSZAtcBDSRr_50QtwQth2KfLIahMHjkfu55jS",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-08-09T01:06:00.287093Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.dFRdzG6vVwIKaxO6WpCLF5q1vPTEPGJdHr2ZufUPMzO8NzijP72yr0oVbknaOTwkw7cgv6403u7N1tW1ejXVChtJieavs3bSiXtZc-pmd7b5RSy4HnocFKsdwYDOcfIiW94ka_wrIG4Wa3TiMTD3mqLFWtdFw0gPe2eeJnGs1R7F37WjFFlJPAK_7HqwhZdI-u4XNRNqr0kXIM15u59espxcA1MmQ7doAHv6awL0c--y0TQj0iDcuGrzSZAtcBDSRr_50QtwQth2KfLIahMHjkfu55jS'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
